import { localized } from '@hr/common/utils'
import styles from './SalaryGapMeter.module.css'

type Props = {
	/** Salary gap ratio, e.g. 0.072 = 7.2 % */
	value: number
}

export function SalaryGapMeter({ value }: Props) {
	const TICKS = [
		'0 %',
		`${localized.numberFormatFraction1.format(2.5)} %`,
		'5 %',
		`${localized.numberFormatFraction1.format(7.5)} %`,
		'10 %',
	]

	const position = Math.min(Math.max(value, 0), 0.1) / 0.1
	//const color = value > 0.1 ? 'var(--color-danger)' : value > 0.05 ? 'var(--color-warning)' : 'var(--color-success)'
	const color = value >= 0.05 ? 'var(--color-warning)' : 'var(--color-success)'

	return (
		<div className={styles.wrapper}>
			<div className={styles.scale}>
				<div
					className={styles.line}
					style={{
						width: `${position * 100}%`,
						backgroundColor: color,
					}}
				>
					{value <= 0.1 && <div className={styles.dot} style={{ backgroundColor: color }} />}
				</div>

				<div className={styles.centerLine} />
			</div>

			<div className={styles.labels}>
				{TICKS.map((label) => (
					<span key={label}>{label}</span>
				))}
			</div>
		</div>
	)
}
